import {
  USER_GET_USERS_REQUEST,
  USER_GET_USERS_SUCCESS,
  USER_GET_USERS_FAIL,
  USER_GET_USER_REQUEST,
  USER_GET_USER_SUCCESS,
  USER_GET_USER_FAIL,
  USER_GET_PROFILE_REQUEST,
  USER_GET_PROFILE_SUCCESS,
  USER_GET_PROFILE_FAIL,
  USER_EDIT_PROFILE_REQUEST,
  USER_EDIT_PROFILE_SUCCESS,
  USER_EDIT_PROFILE_FAIL,
  USER_REMOVE_USER_REQUEST,
  USER_REMOVE_USER_SUCCESS,
  USER_REMOVE_USER_FAIL,
  USER_ASSIGN_ROLE_REQUEST,
  USER_ASSIGN_ROLE_SUCCESS,
  USER_ASSIGN_ROLE_FAIL
} from "../actions/user";

const initialState = {
  getUsersRequest: false,
  getUserRequest: false,
  editUserRequest: false,
  removeUserRequest: false,
  assignRoleRequest: false,
  successBackMsg: "",
  errorMsg: "",
  successMsg: "",
  errors: {},
  users: [],
  usersPagination: {},
  selectedUser: null
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case USER_GET_USERS_REQUEST:
      return {
        ...state,
        getUsersRequest: true,
        errorMsg: "",
        successMsg: "",
        successBackMsg: "",
        errors: {}
      };
    case USER_GET_USERS_SUCCESS:
      return {
        ...state,
        getUsersRequest: false,
        errorMsg: "",
        successMsg: action.msg,
        errors: {},
        users: action.data.data,
        usersPagination: {
          currentPage: action.data.current_page,
          lastPage: action.data.last_page
        }
      };
    case USER_GET_USERS_FAIL:
      return {
        ...state,
        getUsersRequest: false,
        errorMsg: action.msg,
        successMsg: "",
        errors: action.errors
      };
    case USER_GET_USER_REQUEST:
      return {
        ...state,
        getUserRequest: true,
        errorMsg: "",
        successMsg: "",
        errors: {}
      };
    case USER_GET_USER_SUCCESS:
      return {
        ...state,
        getUserRequest: false,
        errorMsg: "",
        successMsg: action.msg,
        errors: {},
        selectedUser: action.user
      };
    case USER_GET_USER_FAIL:
      return {
        ...state,
        getUserRequest: false,
        errorMsg: action.msg,
        successMsg: "",
        errors: action.errors,
        selectedUser: {}
      };
    case USER_GET_PROFILE_REQUEST:
      return {
        ...state,
        getUserRequest: true,
        errorMsg: "",
        successMsg: "",
        errors: {}
      };
    case USER_GET_PROFILE_SUCCESS:
      return {
        ...state,
        getUserRequest: false,
        errorMsg: "",
        successMsg: action.msg,
        errors: {},
        selectedUser: action.user
      };
    case USER_GET_PROFILE_FAIL:
      return {
        ...state,
        getUserRequest: false,
        errorMsg: action.msg,
        successMsg: "",
        errors: action.errors,
        selectedUser: {}
      };
    case USER_EDIT_PROFILE_REQUEST:
      return {
        ...state,
        editUserRequest: true,
        successBackMsg: "",
        errorMsg: "",
        errors: {}
      };
    case USER_EDIT_PROFILE_SUCCESS:
      return {
        ...state,
        editUserRequest: false,
        successBackMsg: action.msg,
        errorMsg: "",
        errors: {}
      };
    case USER_EDIT_PROFILE_FAIL:
      return {
        ...state,
        editUserRequest: false,
        successBackMsg: "",
        errorMsg: action.msg,
        errors: action.errors
      };
    case USER_REMOVE_USER_REQUEST:
      return {
        ...state,
        removeUserRequest: true,
        errorMsg: "",
        successMsg: "",
        errors: {},
        selectedUser: {}
      };
    case USER_REMOVE_USER_SUCCESS:
      return {
        ...state,
        removeUserRequest: false,
        errorMsg: "",
        successMsg: action.msg,
        errors: {},
        selectedUser: {}
      };
    case USER_REMOVE_USER_FAIL:
      return {
        ...state,
        removeUserRequest: false,
        errorMsg: action.msg,
        successMsg: "",
        errors: action.errors,
        selectedUser: {}
      };
    case USER_ASSIGN_ROLE_REQUEST:
      return {
        ...state,
        assignRoleRequest: true,
        errorMsg: "",
        successMsg: "",
        errors: {},
        selectedUser: {}
      };
    case USER_ASSIGN_ROLE_SUCCESS:
      return {
        ...state,
        assignRoleRequest: false,
        errorMsg: "",
        successMsg: action.msg,
        errors: {},
        selectedUser: {}
      };
    case USER_ASSIGN_ROLE_FAIL:
      return {
        ...state,
        assignRoleRequest: false,
        errorMsg: action.msg,
        successMsg: "",
        errors: action.errors,
        selectedUser: {}
      };
    default:
      return state;
  }
};

export default user;
